import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctBytes, FctBytes32 } from '../../../../Fct/generics';
import { secureStorageAddresses } from '../helpers/constants';
export var Write_bytes = createPlugin({
    protocol: 'SECURE_STORAGE',
    type: 'ACTION',
    method: 'write_bytes',
    supportedContracts: secureStorageAddresses,
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({}),
                methodParams: {
                    key: new FctBytes32({ messageType: 'stringOrBytes32' }),
                    value: new FctBytes({ messageType: 'stringOrBytes' }),
                },
            },
            output: {},
        });
    },
});
